import { type FC, useState } from 'react';

import SearchOutlined from '@mui/icons-material/SearchOutlined';

import { IconButton } from '@craft/ui/components/buttons';

import { SearchDialog } from './SearchDialog';

export const SearchBarButton: FC = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <IconButton aria-label='open search panel' onClick={() => setIsDialogOpen(true)}>
        <SearchOutlined sx={{ color: 'background.default' }} />
      </IconButton>
      <SearchDialog isOpen={isDialogOpen} onCancel={() => setIsDialogOpen(false)} />
    </>
  );
};
